import { Markdown as MarkdownBase } from '@toggle/design-system';
import React from 'react';
import { Components } from 'react-markdown';

import { Tracking } from '~/services/tracking';

export interface MarkdownProps {
  message: string;
  onLoad?: (element: HTMLDivElement) => void;
  components?: Partial<Components>;
  isDark?: boolean;
}

export const Markdown = ({
  message,
  onLoad,
  components,
  isDark = true,
}: MarkdownProps) => {
  const logError = (error: Error) => {
    Tracking.captureException(error);
  };

  return (
    <MarkdownBase
      message={message}
      onLoad={onLoad}
      components={components}
      onError={logError}
      isDark={isDark}
    />
  );
};
